import React, { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import MainLayout from './MainLayout'
import RootRoutes from '../../routes/RootRoutes'
import ProtectedRoute from '../../auth/ProtectedRoute'
import { motion } from 'framer-motion'
import CenteredSpinner from '../CenteredSpinner'

const PageTransition = ({ children }) => (
  <motion.div
   /*  initial={{ opacity: 0.5, y: 0 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: 0 }}
    transition={{ duration: 0.15, ease: 'linear' }}
    style={{ height: '100%' }} */

    initial={{ opacity: 0, y: -40 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -40 }}
    transition={{ duration: 0.2, ease: 'easeInOut' }}
    style={{ height: '100%' }}
  >
    {children}
  </motion.div>
)

const LoonsLayout = () => {
    return (
        <MainLayout>
          <PageTransition>
            <Routes>
                {RootRoutes.map((route, i) => (
                    <Route
                        key={i}
                        path={route.path}
                        element={
                            <ProtectedRoute requiredRoles={route.auth || []}>
                                <Suspense fallback={<CenteredSpinner />}>
                                    <div style={{ zoom: 0.9 }}>
                                        <route.component />
                                    </div>
                                </Suspense>
                            </ProtectedRoute>
                        }
                    />
                ))}
            </Routes>
          </PageTransition>
        </MainLayout>
    )
}

export default LoonsLayout 